import { Button } from "@sellar-io/components";
import { SupplierRelationshipList_retailersResponseType } from "@sellar-io/api-v2/types";
import { useRef, useState } from "react";
import { Alert } from "../../../../components/alert/Alert";
import {
  Dialog,
  DialogNavigation,
  DialogContent,
  DialogCTA,
} from "../../../../components/modal/Dialog";
import { apiV2AssertError } from "../../../../hooks/api/v2/apiV2Request";
import { useSupplierRelationshipPaymentTermsRequestCreate } from "../../../../hooks/api/v2/supplierRelationshipPaymentTermsRequest/useSupplierRelationshipPaymentTermsRequestCreate";
import { EditCreditTermsFormFragment } from "../../../customer/businessConnection/connectionSelector/EditCreditTermsFormFragment";

export const CreateConnectionPaymentTermsRequestDialog = ({
  active,
  onDismiss,
  supplierName,
  connectionId,
}: {
  active: boolean;
  connectionId: number;
  supplierName: string;
  onDismiss: () => void;
}) => {
  const mutation = useSupplierRelationshipPaymentTermsRequestCreate();
  const scrollToRef = useRef<HTMLDivElement | null>(null);
  const [paymentDueCalculateFrom, setPaymentDueCalculateFrom] =
    useState<
      SupplierRelationshipList_retailersResponseType[number]["paymentDueCalculateFrom"]
    >();

  const [paymentDue, setPaymentDue] = useState<number | null>();
  const [reasonForRequest, setReasonForRequest] = useState<string | null>();
  const [error, setError] = useState<string>();
  const onSubmit = () => {
    if (!paymentDueCalculateFrom) {
      setError("Payment due calculate from is required");
      return scrollToRef.current?.scrollIntoView({ behavior: "smooth" });
    }
    if (!paymentDue) {
      setError("Payment due is required");
      return scrollToRef.current?.scrollIntoView({ behavior: "smooth" });
    }

    if (!reasonForRequest) {
      setError("Reason for your request if required");
      return scrollToRef.current?.scrollIntoView({ behavior: "smooth" });
    }
    return mutation.mutate(
      {
        paymentDue,
        paymentDueCalculateFrom,
        SupplierRetailerConnectionId: connectionId,
        reasonForRequest,
      },
      {
        onSuccess: () => onDismiss(),
        onError: (e) =>
          setError(
            apiV2AssertError(e)?.response?.data.message ??
              "Unknown error occurred.",
          ),
      },
    );
  };
  return (
    <Dialog active={active} onDismiss={onDismiss}>
      <div ref={scrollToRef}></div>
      <DialogNavigation
        title={`Request credit terms from ${supplierName}`}
        description={
          "If your terms haven't been assigned yet, or you think you've been assigned incorrect terms, you can send a request for your credit terms here."
        }
        leftIcon={"CHEVRON_DOWN"}
        onClickLeftIcon={onDismiss}
      />
      <DialogContent>
        {error ? <Alert type={"error"} message={error} /> : null}
        <EditCreditTermsFormFragment
          setPaymentDue={setPaymentDue}
          paymentDue={paymentDue}
          paymentDueCalculateFrom={paymentDueCalculateFrom}
          setPaymentDueCalculateFrom={setPaymentDueCalculateFrom}
          reasonForRequest={reasonForRequest}
          setReasonForRequest={setReasonForRequest}
          required={true}
        />
      </DialogContent>
      <DialogCTA>
        <Button loading={mutation.isPending} onClick={onSubmit}>
          Confirm
        </Button>
      </DialogCTA>
    </Dialog>
  );
};
